module.exports = __webpack_public_path__ + "img/01-1快消零售.ececf781.png";